<template>
  <div class="stall-profile">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-center">{{ $t('stall.profile') }}</div>
      <div style="width: 24px;"></div>
    </header>

    <!-- 用户信息卡片 -->
    <div class="profile-header">
      <div class="user-avatar">👤</div>
      <div class="user-info">
        <div class="user-name">{{ userInfo.name }}</div>
        <div class="user-shop">{{ $t('stall.stallLabel') }}：{{ userInfo.customerName }}</div>
        <div class="user-phone">{{ $t('stall.phone') }}：{{ userInfo.phone }}</div>
      </div>
    </div>

    <!-- 订单入口 -->
    <div class="order-section">
      <div class="section-header">
        <span class="section-title">📦 {{ $t('stall.myOrders') }}</span>
        <span class="section-more" @click="goToOrders()">{{ $t('stall.viewAll') }} ></span>
      </div>
      <div class="order-menu">
        <div class="order-menu-item" @click="goToOrders('pending')">
          <div class="order-icon">⏳</div>
          <div class="order-label">{{ $t('orderStatus.pending') }}</div>
          <div v-if="stats.pending > 0" class="order-badge">{{ stats.pending }}</div>
        </div>
        <div class="order-menu-item" @click="goToOrders('delivering')">
          <div class="order-icon">🚚</div>
          <div class="order-label">{{ $t('delivery.inTransit') }}</div>
          <div v-if="stats.delivering > 0" class="order-badge">{{ stats.delivering }}</div>
        </div>
        <div class="order-menu-item" @click="goToOrders('done')">
          <div class="order-icon">✅</div>
          <div class="order-label">{{ $t('order.completed') }}</div>
        </div>
        <div class="order-menu-item" @click="goToOrders('refund')">
          <div class="order-icon">🔄</div>
          <div class="order-label">{{ $t('stall.afterSales') }}</div>
        </div>
      </div>
    </div>

    <!-- 功能菜单 -->
    <div class="menu-section">
      <div class="menu-group">
        <div class="menu-item" @click="goToAddress()">
          <span class="menu-icon">📍</span>
          <span class="menu-label">{{ $t('order.deliveryAddress') }}</span>
          <span class="menu-arrow">›</span>
        </div>
        <div class="menu-item" @click="goToShopInfo()">
          <span class="menu-icon">🏪</span>
          <span class="menu-label">{{ $t('user.shopInfo') }}</span>
          <span class="menu-arrow">›</span>
        </div>
        <div class="menu-item" @click="goToShareStats()">
          <span class="menu-icon">📢</span>
          <span class="menu-label">{{ $t('Stall.StallProfile.line62_text') }}</span>
          <span class="menu-arrow">›</span>
        </div>
      </div>
    </div>

    <!-- 退出登录 -->
    <div class="logout-section">
      <button class="btn-logout" @click="showChangePassword = true">🔐 {{ $t('stall.changePassword') }}</button>
      <button class="btn-logout" @click="handleLogout()">{{ $t('auth.logout') }}</button>
    </div>

    <!-- 删除账号 -->
    <div class="delete-account-section">
      <button class="btn-delete-account" @click="showDeleteAccount = true">{{ $t('common.deleteAccount') }}</button>
    </div>

    <!-- 底部导航 -->
    <nav class="bottom-nav">
      <button class="nav-item" @click="navigateTo('products')">
        <span class="nav-item-icon">🏠</span>
        <span>{{ $t('navigation.home') }}</span>
      </button>
      <button class="nav-item" @click="navigateTo('cart')">
        <span class="nav-item-icon">🛒</span>
        <span>{{ $t('navigation.cart') }}</span>
        <span v-if="cartCount > 0" class="cart-badge">{{ cartCount }}</span>
      </button>
      <button class="nav-item" @click="navigateTo('orders')">
        <span class="nav-item-icon">📋</span>
        <span>{{ $t('navigation.orders') }}</span>
        <span v-if="pendingOrders > 0" class="cart-badge">{{ pendingOrders }}</span>
      </button>
      <button class="nav-item active" @click="navigateTo('profile')">
        <span class="nav-item-icon">👤</span>
        <span>{{ $t('navigation.profile') }}</span>
      </button>
    </nav>

    <!-- 修改密码弹窗 -->
    <ChangePasswordModal :visible.sync="showChangePassword" />

    <!-- 删除账号弹窗 -->
    <div class="delete-account-modal" v-if="showDeleteAccount">
      <div class="modal-overlay" @click="showDeleteAccount = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h3>{{ $t('Stall.StallProfile.line109_text') }}</h3>
            <button class="close-btn" @click="showDeleteAccount = false">×</button>
          </div>
          <div class="modal-body">
            <p class="warning-text">{{ $t('Stall.StallProfile.line113_text') }}</p>
            <ul class="warning-list">
              <li>{{ $t('Stall.StallProfile.line115_text') }}</li>
              <li>{{ $t('Stall.StallProfile.line116_text') }}</li>
              <li>{{ $t('Stall.StallProfile.line117_text') }}</li>
              <li>{{ $t('Stall.StallProfile.line118_text') }}</li>
            </ul>
            <p class="warning-text danger">{{ $t('Stall.StallProfile.line120_text') }}</p>
          </div>
          <div class="modal-footer">
            <button class="btn-cancel" @click="showDeleteAccount = false">{{ $t('common.cancel') }}</button>
            <button class="btn-confirm-danger" @click="confirmDeleteAccount">{{ $t('common.confirmDelete') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from '@/utils/auth';
import ChangePasswordModal from '@/components/ChangePasswordModal.vue';
import api from '@/services/api';
export default {
  name: 'StallProfile',
  components: { ChangePasswordModal },
  data() {
    return {
      userInfo: {
        name: '',
        customerName: '',
        phone: ''
      },
      stats: {
        pending: 0,
        delivering: 0,
        done: 0
      },
      cartCount: 0,
      pendingOrders: 0,
      showChangePassword: false,
      showDeleteAccount: false
    };
  },
  mounted() {
    this.loadUserInfo();
    this.loadOrderStats();
    this.loadCartCount();
  },
  methods: {
    async loadUserInfo() {
      try {
        const customerId = localStorage.getItem('stored_customer_id');
        if (customerId) {
          const customer = await api.get(`/customers/${customerId}`);
          if (customer) {
            this.userInfo.customerName = customer.customerName || customer.companyName || '-';
            this.userInfo.phone = customer.contactPhone || customer.phone || '-';
          }
        }
      } catch (e) {
        console.warn('Failed to load customer info:', e);
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        this.userInfo.customerName = userInfo.customerName || userInfo.stallName || '-';
        this.userInfo.phone = userInfo.phone || '-';
      }
      // 用户名从 localStorage 取
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      this.userInfo.name = userInfo.realName || userInfo.username || '-';
    },
    async loadOrderStats() {
      try {
        const response = await api.get('/orders', {
          params: { page: 1, size: 1000 }
        });
        const orders = response?.items || [];
        this.stats.pending = orders.filter(o => ['pending', 'pending_payment', 'underpaid'].includes((o.status || '').toLowerCase())).length;
        this.stats.delivering = orders.filter(o => ['delivering', 'in_transit', 'packed'].includes((o.status || '').toLowerCase())).length;
        this.stats.done = orders.filter(o => ['delivered', 'completed'].includes((o.status || '').toLowerCase())).length;
        this.pendingOrders = this.stats.pending + this.stats.delivering;
      } catch (e) {
        console.warn('Failed to load order stats:', e);
      }
    },
    loadCartCount() {
      const cart = JSON.parse(localStorage.getItem('stall_cart') || '[]');
      this.cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);
    },
    navigateTo(tab) {
      const routes = {
        home: '/stall/home',
        products: '/stall/products',
        cart: '/stall/cart',
        orders: '/stall/orders',
        profile: '/stall/profile'
      };
      const targetRoute = routes[tab];
      // 避免重复导航到当前页面
      if (targetRoute && this.$route.path !== targetRoute) {
        this.$router.push(targetRoute).catch(err => {
          // 忽略 NavigationDuplicated 错误
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation failed:', err);
          }
        });
      }
    },
    goToOrders(status) {
      const path = status ? `/stall/orders?status=${status}` : '/stall/orders';
      this.$router.push(path);
    },
    goToAddress() {
      this.$router.push('/stall/addresses');
    },
    goToShopInfo() {
      this.$router.push('/stall/shop-info');
    },
    goToShareStats() {
      this.$router.push('/customer/share-stats');
    },
    showToast(msg) {
      this.$toast?.info(msg);
    },
    handleLogout() {
      logout();
    },
    async confirmDeleteAccount() {
      try {
        const res = await api.delete('/auth/account');
        // 响应拦截器 code===200 时返回 data（可能是字符串），成功即 truthy
        if (res !== undefined && res !== null) {
          this.$toast?.success('账号已删除');
          this.showDeleteAccount = false;
          // 清除本地存储
          localStorage.clear();
          sessionStorage.clear();
          // 跳转到登录页
          this.$router.replace('/login');
        } else {
          this.$toast?.error('删除失败');
        }
      } catch (error) {
        console.error('删除账号失败:', error);
        this.$toast?.error('删除失败：' + (error.response?.data?.message || error.message));
      }
    }
  }
};
</script>

<style scoped>
.stall-profile {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 60px;
}

/* ==================== Header ==================== */
.header {
  background: white;
  border-bottom: 1px solid #eee;
  padding: calc(12px + env(safe-area-inset-top, 0px)) 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-center {
  flex: 1;
  text-align: center;
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.btn-icon {
  font-size: 20px;
  cursor: pointer;
  background: none;
  border: none;
  color: #333;
}

/* ==================== Profile Header ==================== */
.profile-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
}

.user-avatar {
  font-size: 48px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.2);
  border-radius: 50%;
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 4px;
}

.user-shop,
.user-phone {
  font-size: 12px;
  opacity: 0.9;
  margin-bottom: 2px;
}

/* ==================== Order Section ==================== */
.order-section {
  background: white;
  margin: 12px;
  border-radius: 8px;
  padding: 16px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.section-more {
  font-size: 12px;
  color: #999;
  cursor: pointer;
}

.order-menu {
  display: flex;
  justify-content: space-around;
}

.order-menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.order-icon {
  font-size: 28px;
  margin-bottom: 6px;
}

.order-label {
  font-size: 12px;
  color: #666;
}

.order-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #f5576c;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: bold;
}

/* ==================== Menu Section ==================== */
.menu-section {
  margin: 12px;
}

.menu-group {
  background: white;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  transition: background 0.2s;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:active {
  background: #f9f9f9;
}

.menu-icon {
  font-size: 20px;
  margin-right: 12px;
  width: 24px;
}

.menu-label {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.menu-arrow {
  font-size: 20px;
  color: #ccc;
}

/* ==================== Logout Section ==================== */
.logout-section {
  padding: 24px 16px 100px;
}

.btn-logout {
  width: 100%;
  padding: 14px;
  background: white;
  color: #f5576c;
  border: 1px solid #f5576c;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-logout:active {
  background: #f5576c;
  color: white;
}

.btn-danger {
  background: #fff5f5;
  color: #f5576c;
  border-color: #f5576c;
}

.btn-danger:active {
  background: #f5576c;
  color: white;
}

/* ==================== 删除账号 ==================== */
.delete-account-section {
  padding: 12px 16px 24px;
}

.btn-delete-account {
  width: 100%;
  padding: 12px;
  background: none;
  color: #bbb;
  border: none;
  font-size: 13px;
  cursor: pointer;
}

.btn-delete-account:active {
  color: #999;
}

/* ==================== Modal ==================== */
.delete-account-modal .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  opacity: 1 !important;
  visibility: visible !important;
}

.delete-account-modal .modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.delete-account-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.delete-account-modal .modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.delete-account-modal .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
}

.delete-account-modal .modal-body {
  padding: 20px;
}

.delete-account-modal .warning-text {
  font-size: 14px;
  color: #666;
  margin: 8px 0;
  line-height: 1.5;
}

.delete-account-modal .warning-text.danger {
  color: #f5576c;
  font-weight: bold;
}

.delete-account-modal .warning-list {
  margin: 8px 0;
  padding-left: 0;
  list-style: none;
}

.delete-account-modal .warning-list li {
  font-size: 14px;
  color: #666;
  margin: 4px 0;
}

.delete-account-modal .modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #eee;
}

.delete-account-modal .btn-cancel {
  flex: 1;
  padding: 12px;
  background: #f0f0f0;
  color: #666;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.delete-account-modal .btn-confirm-danger {
  flex: 1;
  padding: 12px;
  background: #f5576c;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.delete-account-modal .btn-confirm-danger:active {
  background: #e04858;
}

/* ==================== Bottom Navigation ==================== */
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  z-index: 100;
  height: 56px;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 11px;
  border: none;
  background: none;
  transition: color 0.3s;
  position: relative;
}

.nav-item.active {
  color: #667eea;
}

.nav-item-icon {
  font-size: 24px;
  margin-bottom: 2px;
}

.cart-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #f5576c;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
}
</style>
